export enum SolidButtonColorSchemas {
  PURPLE = "purple",
  WHITE = "white",
  TRANSPARENT = "transparent",
}
